"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChecklistActionType = void 0;
var ChecklistActionType;
(function (ChecklistActionType) {
    ChecklistActionType["UNKNOWN"] = "UNKNOWN";
    ChecklistActionType["CLICK"] = "CLICK";
    ChecklistActionType["COMPLETE"] = "COMPLETE";
})(ChecklistActionType || (exports.ChecklistActionType = ChecklistActionType = {}));
